import { NestedOption, Option } from '~/core/shared/types/utility';

/**
 * Select copies its options into state whenever their identity changes, so a level keeps the
 * same array for as long as its source options are unchanged. The source arrays are the
 * levels of the field's own tree, which is why they make a stable key.
 */
const selectOptionsBySource = new WeakMap<
  readonly NestedOption[],
  Array<Option<string>>
>();

export const toSelectOptions = (
  options: readonly NestedOption[],
): Array<Option<string>> => {
  let selectOptions = selectOptionsBySource.get(options);

  if (!selectOptions) {
    selectOptions = options.map(({ label, value }) => ({ label, value }));
    selectOptionsBySource.set(options, selectOptions);
  }

  return selectOptions;
};
